import { useSite } from "@/context/SiteContext";
import { PageHero, SectionHead, DoodleBand, LightSection, DoodlePhoto } from "@/components/site/Shared";
import { ScheduleBlock } from "@/components/site/ScheduleBlock";
import { LeadForm } from "@/components/site/LeadForm";

const FIELDS = [
  { name: "name", label: "Full name", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone" },
  { name: "interest", label: "I'm most interested in", type: "select", options: ["Open mics", "Writing workshops", "Literacy circles", "Just listening", "All of it"] },
  { name: "message", label: "Anything we should know?", type: "textarea" },
];

export default function PoetryClub() {
  const { settings: s } = useSite() || {};
  if (!s) return <div className="h-[80vh]" />;
  return (
    <div data-testid="poetry-club-page">
      <LightSection id="join" className="scroll-mt-20">
        <div className="container-mas py-12 sm:py-16 grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 space-y-8">
            <SectionHead light eyebrow="the poetry club · free registration" title="Join the Poetry Club" intro="No fees, no auditions. Register once and we'll keep you posted on every gathering." />
            <DoodlePhoto src={s.images?.hero} className="h-72 hidden lg:block" />
          </div>
          <div className="lg:col-span-7 bg-white p-6 sm:p-8 shadow-[10px_10px_0_#245E55]">
            <LeadForm type="club_registration" fields={FIELDS} submitLabel="Register — it's free" successText="Welcome to the Poetry Club!" />
          </div>
        </div>
      </LightSection>

      <PageHero testid="poetry-club-hero" eyebrow="the poetry club · free" title="Pull up a chair. Read if you want." intro={s.club_meeting_info} image={s.images?.club}>
        <a href="#gatherings" className="btn-terra" data-testid="poetry-club-gatherings-link">Upcoming gatherings</a>
      </PageHero>

      <section className="container-mas py-16 sm:py-20 grid md:grid-cols-2 gap-4">
        <div className="bg-quartz text-ink p-8 sm:p-10" data-testid="poetry-club-culture">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] mb-4">our culture</p>
          <p className="text-xl sm:text-2xl leading-snug whitespace-pre-line">{s.club_culture}</p>
        </div>
        <div className="bg-tea text-shell p-8 sm:p-10" data-testid="poetry-club-history">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] mb-4 text-mustard">our history</p>
          <p className="text-base sm:text-lg font-light leading-relaxed whitespace-pre-line">{s.club_history}</p>
        </div>
      </section>

      <DoodleBand />

      <section id="gatherings" className="container-mas py-16 sm:py-20 scroll-mt-24">
        <SectionHead eyebrow="upcoming gatherings" title={`${s.events_per_year}+ events a year. All free.`} className="mb-8" />
        <ScheduleBlock />
      </section>
    </div>
  );
}
